module.exports = __webpack_public_path__ + "img/170.9f8defd8.jpg";